<template>
  <div class="registeredUsers">
    <div class="searchWrap">
      <span class="label"> {{ $tt("名称：") }} </span>
      <el-input
        v-model="searchCnName"
        clearable
        :placeholder="$tt('请输入名称')"
      ></el-input>
      <span class="label"> {{ $tt("昵称：") }} </span>
      <el-input
        v-model="searchNickName"
        clearable
        :placeholder="$tt('请输入昵称')"
      ></el-input>
      <span class="label"> {{ $tt("手机号：") }} </span>
      <el-input
        v-model="searchValue"
        clearable
        :placeholder="$tt('请输入手机号')"
      ></el-input>
      <span class="label"> {{ $tt("邮箱：") }} </span>
      <el-input
        v-model="searchEmail"
        clearable
        :placeholder="$tt('请输入邮箱')"
      ></el-input>
      <span class="label"> {{ $tt("状态：") }} </span>
      <el-select v-model="selectedStatus" clearable :placeholder="$tt('请选择')">
        <el-option
          v-for="item in statusOptions"
          :label="$tt(item.label)"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">{{ $tt("搜索") }}</el-button>
      <el-button type="success" plain @click="batchAi(1)">{{ $tt("一键全开 AI") }}</el-button>
      <el-button type="warning" plain @click="batchAi(0)">{{ $tt("一键全关 AI") }}</el-button>
    </div>
    <el-table
      :data="tableDataInfo.result"
      style="width: 100%"
      class="usersTable"
      border
      :max-height="listTableMaxHeight"
    >
      <el-table-column
        v-for="c in tableColumns"
        :key="c.prop"
        :label="$tt(c.label)"
        :width="$listColWidth(c)"
        :min-width="$listColMinWidth(c)"
        :prop="$listColProp(c)"
        :sortable="$listSortable(c)"
        :class-name="$listColClass(c)"
        :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
        :show-overflow-tooltip="$listOverflow(c)"
      >
        <template slot-scope="scope">
          <div v-if="c.prop.indexOf('time') > -1">
            {{ dateTransform(scope.row[c.prop]) }}
          </div>
          <div
            v-else-if="c.prop == 'status'"
            :class="[statusConfig[scope.row.status].class]"
          >
            {{ $tt(statusConfig[scope.row.status].text) }}
          </div>
          <div v-else-if="c.prop == 'ai_visible'">
            <el-switch
              :value="Number(scope.row.ai_visible != null ? scope.row.ai_visible : scope.row.aiVisible) === 1"
              @change="(on) => toggleAi(scope.row, on)"
            />
          </div>
          <div class="table-ops" v-else-if="c.prop == 'operations'">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-refresh"
              @click="resetUserPassword(scope.row.id)"
              >{{ $tt("重置密码") }}</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row.id)"
              >{{ $tt("用量") }}</el-button>
            <el-button
              size="mini"
              type="text"
              :icon="statusConfig[scope.row.status].type === 'danger' ? 'el-icon-circle-close' : 'el-icon-circle-check'"
              :class="statusConfig[scope.row.status].type === 'danger' ? 'table-op-danger' : ''"
              @click="switchStatus(scope.row)"
              >{{ $tt(statusConfig[scope.row.status].btnText) }}</el-button>
          </div>
          <span v-else>{{ scope.row[c.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="tableDataInfo.total > 8"
      :handleSizeChange="handleSizeChange"
      :handleCurrentPageChange="handleCurrentPageChange"
      :total="tableDataInfo.total"
    />
  </div>
</template>

<script>
import moment from "moment";
import Pagination from "@/components/Pagination";
export default {
  listTableTopOffset: 300,
  data() {
    return {
      tableColumns: [
        {
          label: "用户名称",
          prop: "cn_name",
        },
        {
          label: "昵称",
          prop: "nick_name",
        },
        {
          label: "邮箱",
          prop: "email",
        },
        {
          label: "注册时间",
          prop: "create_time",
        },
        {
          label: "电话号码",
          prop: "phone",
        },
        {
          label: "免费容量（M）",
          prop: "free_capacity",
        },
        {
          label: "工程数量",
          prop: "projects",
          width: "90",
        },
        {
          label: "页面个数",
          prop: "pages",
          width: "90",
        },
        {
          label: "近一次登录时间",
          prop: "last_login_time",
        },
        {
          label: "随机序列号",
          prop: "random_code",
        },
        {
          label: "状态",
          prop: "status",
        },
        {
          label: "AI可见",
          prop: "ai_visible",
          width: "90",
        },
        {
          label: "操作",
          prop: "operations",
          width: "260",
        },
      ],
      tableDataInfo: {},
      selectedStatus: "",
      searchValue: "",
      searchCnName: "",
      searchNickName: "",
      searchEmail: "",
      statusOptions: [
        {
          label: "正常",
          value: "true",
        },
        {
          label: "禁用",
          value: "false",
        },
      ],
      statusConfig: {
        true: {
          text: "正常",
          btnText: "禁用",
          class: "normal",
          type: "danger",
        },
        false: {
          text: "禁用",
          btnText: "启用",
          class: "forbid",
          type: "primary",
        },
      },
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getTableData({});
  },
  methods: {
    handleSizeChange(v) {
      this.getTableData({ page_size: v });
    },
    handleCurrentPageChange(v) {
      this.getTableData({ page_num: v });
    },
    getTableData({ phone, status, cn_name, nick_name, email, page_size = 8, page_num = 1 }) {
      this.$request
        .queryRegisteredUsers({ page_num, page_size, phone, status, cn_name, nick_name, email })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.tableDataInfo = res.data || {};
        });
    },
    handleEdit(id) {
      this.$router.push({
        path: "/userManage/users/edit",
        query: {
          id,
        },
      });
    },
    switchStatus({ id, status }) {
      this.$request
        .updateUserStatus({ id, status: status == "true" ? "false" : "true" })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.getTableData({});
        });
    },
    resetUserPassword(id) {
      this.$confirm("将密码重置为 123456，并强制下次登录改密，同时踢出在线会话？", "重置密码", {
        type: "warning",
      }).then(() => {
        this.$request.adminResetUserPassword({ id }).then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.$message.success("已重置");
        });
      }).catch(() => {});
    },
    search() {
      this.getTableData({
        phone: this.searchValue,
        status: this.selectedStatus,
        cn_name: this.searchCnName,
        nick_name: this.searchNickName,
        email: this.searchEmail,
      });
    },
    toggleAi(row, on) {
      const id = row.id || row.user_id;
      this.$request
        .updateUserAiVisible({ id, ai_visible: on ? 1 : 0 })
        .then((res) => {
          if (!res || res.status != "success") {
            this.$message.error((res && res.msg) || "更新失败");
            return;
          }
          this.$set(row, "ai_visible", on ? 1 : 0);
          this.$set(row, "aiVisible", on ? 1 : 0);
        });
    },
    batchAi(aiVisible) {
      const text = aiVisible ? "全员开启画布 AI？" : "全员关闭画布 AI？";
      this.$confirm(text, "提示", { type: "warning" })
        .then(() => {
          return this.$request.batchUserAiVisible({ ai_visible: aiVisible });
        })
        .then((res) => {
          if (!res) return;
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.$message.success("已更新");
          this.getTableData({});
        })
        .catch(() => {});
    },
    dateTransform(d) {
      return moment(d).format("YYYY-MM-DD HH:mm");
    },
  },
};
</script>

<style lang='scss' scoped>
.registeredUsers {
  padding: 24px;
  background-color: #fff;
  .searchWrap {
    display: flex;
    border-bottom: 1px solid #e6e6e6;
    padding: 16px 0;
    align-items: center;
    .label {
      margin-left: 16px;
    }
    .el-input {
      width: 200px !important;
    }
    .el-button {
      margin-left: 16px;
    }
  }
  .usersTable {
    .normal {
      color: #67c23a;
    }
    .forbid {
      color: #f56c6c;
    }
  }
}
</style>